import React, { useState, useEffect, useRef } from 'react';

// material ui
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import useStyles from './styles';

import isNumeric from 'validator/lib/isNumeric';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';

function SubForm02({ id, setValue, saveValueJump, saveValue, value, no_kk, handleBackSub, isSubmitting }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});

    const [hamil, setHamil] = useState(value.sedang_hamil || '')
    const [usiaHamil, setUsiaHamil] = useState(value.usia_kehamilan || '')
    const [inginHamil, setInginHamil] = useState(value.sedang_hamil_ingin || '')
    const [inginAnak, setInginAnak] = useState(value.ingin_anak || '')

    useEffect(() => {
        setError({})
    }, [])

    const pertanyaan = "Apakah Ibu saat ini sedang hamil ?";
    const handleChange = (e) => {

        if (e.target.type === "number" && parseInt(e.target.value) < 0) {
            return false;
        }

        if (e.target.name === "usia_kehamilan" && (e.target.value > 48)) {
            value.usia_kehamilan = 48;
            setUsiaHamil(48)
            return false;
        }

        if(e.target.name === "sedang_hamil"){
            value.usia_kehamilan = null;
            setUsiaHamil(null);
            value.sedang_hamil_ingin = null;
            setInginHamil(null);
            value.ingin_anak = null;
            setInginAnak(null);
        }

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        switch (e.target.name) {
            case 'sedang_hamil':
                setHamil(e.target.value)
                break;
            case 'usia_kehamilan':
                setUsiaHamil(e.target.value)
                break;
            case 'sedang_hamil_ingin':
                setInginHamil(e.target.value)
                break;
            case 'ingin_anak':
                setInginAnak(e.target.value)
                break;
            default:
                break;
        }

        // setSomethingChange(true)
    }

    useEffect(() => {

        // console.log("hamil => ",hamil)
        // console.log("usia hamil => ",usiaHamil)
        // console.log("ingin hamil => ",inginHamil)
        // console.log("ingin anak => ",inginAnak)

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 2,
            No_KK: no_kk,
        }

        if (hamil === "1") {
            normalizeValue.answer = [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: hamil,
                    Jawaban_D1: usiaHamil ? usiaHamil : 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: inginHamil ? inginHamil : 0,
                    Lainnya: ""
                }

            ]
        } else if (hamil === "2") {
            normalizeValue.answer = [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: hamil,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: inginAnak ? inginAnak : 0,
                    Lainnya: ""
                }

            ]
        }

        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        //console.log("save jump => ", normalizeValue)
        saveValueJump(normalizeValue)

    }, [hamil, usiaHamil, inginHamil, inginAnak])

    const validate = () => {
        let newError = {};

        if (!value.sedang_hamil) {
            newError.sedang_hamil = "Wajib diisi";
        }

        if (value.sedang_hamil === "1") {
            if (!value.usia_kehamilan) {
                newError.usia_kehamilan = "Usia kehamilan wajib diisi";
            } else if (!isNumeric(value.usia_kehamilan)) {
                newError.usia_kehamilan = "Usia kehamilan tidak valid";
            } else if (parseInt(value.usia_kehamilan) <= 0 || parseInt(value.usia_kehamilan) > 48) {
                newError.usia_kehamilan = "Usia kehamilan maksimal 48 minggu";
            }

            if (!value.sedang_hamil_ingin) {
                // newError.sedang_hamil_ingin = "Wajib diisi";
                newError.sedang_hamil_ingin = " Keinginan hamil belum dijawab";
            }
        } else if (value.sedang_hamil === "2") {
            if (!value.ingin_anak) {
                // newError.ingin_anak = "Wajib diisi";
                newError.ingin_anak = "Keinginan memiliki anak belum dijawab";
            }
        }


        return newError;
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {
            //console.log(value)
            // const normalizeValue = {
            //     pertanyaan,
            //     jawaban_1: value.sedang_hamil,
            //     jawaban_2: value.usia_kehamilan ? value.usia_kehamilan : ''

            // }
            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 2,
                No_KK: no_kk,
            }

            if (value.sedang_hamil === "1") {
                normalizeValue.answer = [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.sedang_hamil,
                        Jawaban_D1: value.usia_kehamilan ? value.usia_kehamilan : 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.sedang_hamil_ingin ? value.sedang_hamil_ingin : 0,
                        Lainnya: ""
                    }

                ]
            } else if (value.sedang_hamil === "2") {
                normalizeValue.answer = [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: value.sedang_hamil,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.ingin_anak ? value.ingin_anak : 0,
                        Lainnya: ""
                    }

                ]
            }

            if (value._rev) {
                normalizeValue._rev = value._rev
            }
            saveValue(normalizeValue)
        }
    }

    return (
        <>
            <form id={id} onSubmit={handleSubmit} noValidate>
                <div className={classes.card}>
                    <div className={classes.cardHeader}>
                        <Typography margin="normal" paragraph>
                            <span className={classes.badge}>02</span>{pertanyaan}</Typography>
                        <div style={{ position: "absolute", right: "0", top: "58px" }}>
                            <InfoButton
                                content={
                                    "Usia kehamilan dalam satuan minggu, dengan maksimal 48 minggu."
                                }
                            />
                        </div>
                    </div>
                    <div className={classes.cardBody}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={3}>
                                <FormControl error={error.sedang_hamil ? true : false} component="fieldset">
                                    <RadioGroup value={value.sedang_hamil || ''}
                                        onChange={handleChange}
                                        aria-label="sedang_hamil" name="sedang_hamil">
                                        <FormControlLabel control={<Radio />}
                                            value="1"
                                            label="1. Ya" />
                                        <FormControlLabel control={<Radio />}
                                            value="2"
                                            label="2. Tidak" />
                                    </RadioGroup>
                                    <FormHelperText>{error.sedang_hamil}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {value.sedang_hamil === '1' &&
                                <>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            label="Usia Kehamilan"
                                            placeholder=""
                                            variant="outlined"
                                            id="usia_kehamilan"
                                            name="usia_kehamilan"
                                            value={value.usia_kehamilan || ''}
                                            onChange={handleChange}
                                            InputProps={{

                                                endAdornment: <InputAdornment
                                                    className={classes.inputAdornmentNoWrap}
                                                    position="end">Minggu</InputAdornment>,
                                            }}
                                            type="number"
                                            inputProps={{

                                                className: classes.inputMini,
                                                min: 0,
                                                max: 48,
                                                maxLength: 2
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            error={error.usia_kehamilan ? true : false}
                                            helperText={error.usia_kehamilan}

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography><strong>1.1 Jika YA, saat mulai hamil, apakah Ibu memang ingin hamil saat itu, ingin hamil nanti atau tidak ingin anak lagi?</strong></Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl
                                            error={error.sedang_hamil_ingin ? true : false}
                                            component="fieldset">
                                            <RadioGroup value={value.sedang_hamil_ingin || ''}
                                                onChange={handleChange}
                                                aria-label="sedang_hamil_ingin" name="sedang_hamil_ingin">
                                                <FormControlLabel control={<Radio />}
                                                    value="1"
                                                    label="1. Ya, ingin hamil saat itu" />
                                                <FormControlLabel control={<Radio />}
                                                    value="2"
                                                    label="2. Ingin hamil nanti/kemudian" />
                                                <FormControlLabel control={<Radio />}
                                                    value="3"
                                                    label="3. Tidak ingin anak lagi" />
                                            </RadioGroup>
                                            <FormHelperText>{error.sedang_hamil_ingin}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </>
                            }
                            {
                                value.sedang_hamil === "2" &&
                                <>
                                    <Grid item xs={12}>
                                        <Typography><strong>2.1 Jika Tidak, apakah Ibu menginginkan anak lagi?</strong></Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl
                                            error={error.ingin_anak ? true : false}
                                            component="fieldset">
                                            <RadioGroup value={value.ingin_anak || ''}
                                                onChange={handleChange}
                                                aria-label="ingin_anak" name="ingin_anak">
                                                <FormControlLabel control={<Radio />}
                                                    value="1"
                                                    label="1. Ya. Ingin anak segera (<=2 tahun)" />
                                                <FormControlLabel control={<Radio />}
                                                    value="2"
                                                    label="2. Ya. Ingin anak nanti/kemudian (>2 tahun)" />
                                                <FormControlLabel control={<Radio />}
                                                    value="3"
                                                    label="3. Tidak ingin anak lagi" />
                                                {/* <FormControlLabel control={<Radio />}
                                    value="4"
                                    label="Tidak dapat hamil" /> */}
                                            </RadioGroup>
                                            <FormHelperText>{error.ingin_anak}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </>
                            }


                        </Grid>
                    </div>
                </div>
            </form>

            <Grid item xs style={{ marginTop: 20 }}>
                <Button
                    ref={backRef}
                    // disabled={!isSomethingChange || isSubmitting}
                    onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

                {isSubmitting && <CircularProgress size={14} />}
                <Button
                    style={{ float: 'right' }}
                    ref={nextRef}
                    form={id}
                    disabled={isSubmitting}
                    type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
            </Grid>
        </>
    )
}

export default SubForm02;